<template>
  <ChipGeneric
    :item="computed_item"
    :key="'item_'+item.value"
    @update="chip_clicked"
  />
</template>
  
  
<style lang="scss">
</style>
  
  
<script>
  import { mapState } from 'vuex';
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';

  
  export default {
    name: 'ProcessChip',
  
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
  
    components: {
      ChipGeneric
    },

    computed: {
      ...mapState(['allProcesses']),
      computed_item() {
        return  {
                  readable: this.text,
                  readableValue: this.current_process.name,
                }
      },
      text() {
        return this.item.readable ||  this.$vuetify.lang.translator('chips.process');
      },
      current_process() {
        return this.allProcesses.find(prc => prc.id === this.item.value);
      },
      current_value() {
        return this.current_process ? this.current_process.name : ''+this.item.value
      },
    },
  
    methods: {
      chip_clicked(){
        this.$emit('update',this.item);
      },    
    },
  }
</script>